import Button from "@/components/Button";
import { type Path, useNavigate } from "@/router";

export interface RowLinkProps {
  columnCount: number;
  children?: React.ReactNode;
  to?: Path;
  onClick?: () => void;
  testId?: string;
  rowTestId?: string;
}

export default function RowLink({
  columnCount,
  children = "View More",
  to,
  onClick,
  testId,
  rowTestId = "table-row-link"
}: RowLinkProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (to) {
      navigate(to);
    }
  };

  return (
    <tr className="border-t border-sys-brand-surface-container-highest" data-testid={rowTestId}>
      <td colSpan={columnCount} className="py-2 text-center">
        <Button variant="text" onClick={handleClick} testId={testId} disabled={!onClick && !to}>
          {children}
        </Button>
      </td>
    </tr>
  );
}
